
/* injects from baggage-loader */

'use strict';

import ProductGroupsController from './product-groups.controller';
import ProductGroupsTemplate from './product-groups.html';

export default class ProductGroupsComponent {
		constructor() {
				this.templateUrl = ProductGroupsTemplate;
				this.controller = ProductGroupsController;
				this.controllerAs = 'ctrl';
				// Bind resolved items to the controller, see module state for resolve
				this.bindings = { 
					groups: '<'
				};
		}
}



// WEBPACK FOOTER //
// ./src/app/pages/product-groups/product-groups.component.js